import { useMemo } from "react";
import { useMarketingResourceTopics } from "creso-core/hooks";
import type { MarketingResourceType } from "creso-core/types";
import { ResourceFilterOption } from "creso-core/utils";

export function useResourceTopicFilters(resourceType: MarketingResourceType) {
  const enabled = resourceType !== "guide";
  const { data: topics = [], isLoading } = useMarketingResourceTopics(
    { resource_type: resourceType },
    { enabled }
  );

  const filterOptions: ResourceFilterOption[] = useMemo(
    () =>
      topics.map((topic) => ({
        key: String(topic.id),
        label: topic.name,
        count: Number(topic.resource_count) || 0,
      })),
    [topics]
  );

  return { filterOptions, isLoading: enabled ? isLoading : false };
}

export function getSelectedTopicIds(selectedFilters: string[]) {
  return selectedFilters
    .map((value) => Number(value))
    .filter((value) => Number.isFinite(value));
}
